<template>
<div>

<previewimage1 ref="preview1" />

<section class="hero ls-main-hero">
    <div class="hero-head">
        <truenav />
    </div>

    <div class="hero-body container">
        <div class="columns">
            <div class="column left is-6-desktop">
                <br><br>
                <!--<div class="ls-banner has-text-white">
                    <span class="tag is-success has-text-info is-size-6-mobile is-size-7">New</span>
                    <span class="ls-banner--text is-size-6-mobile is-size-7">Dynamic Tables now available for your docs.</span>
                   <span class="ls-banner--icon"><i aria-hidden="true" class="fas fa-chevron-right"></i></span> 
                </div>-->
                

                <h1 class="title is-size-2-mobile is-1 has-text-white">Automate your docs.<br>Within minutes.</h1>
                <br>


                <!--<div class="buttons is-centered">
                    <a @click="googleSignIn" class="ls-button button has-text-weight-bold is-white"><span class="icon">
                              <img alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg">
                            </span>
                            <span style="color:#757575!important">&nbsp;&nbsp;Get Started with Google</span></a>
                </div>

               <div class="buttons is-centered">
                   <a @click="goToSignup" class="ls-button button has-text-weight-bold" style="background-color: #db4437 ; border-color:transparent"><span class="icon">
                              <img class="firebaseui-idp-icon" alt = "" src = "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg" >
                            </span>
                            <span style="color:#fff!important">&nbsp;&nbsp;Get Started with Email</span></a>
                </div>-->


               <div class="buttons is-centered">
                   <!--<a @click="goToSignup" class="ls-button button has-text-weight-bold is-success">Try for Free</a>-->
                   <a  href="https://app.minutemerge.com/signup" class="ls-button button has-text-weight-bold is-success mybutton">Get Started</a>
                   <a  href="#" class="ls-button button has-text-weight-bold is-success mybuttonmobile">Soon on Mobile...</a>
                   <!--<a   class="ls-button button has-text-weight-bold is-success">Coming Soon...</a>-->
                </div>


            </div>
            <div class="column right is-5-desktop is-offset-1-desktop">
                <img class="ls-main-hero--image" src="../img/AffiinityCorrected.svg" alt="Editor">
            </div>
        </div>
    </div>
</section>





<section class="section ls-features-cards"><div class="container"><div class="columns"><div class="column is-8-desktop is-offset-2-desktop"><div class="ls-section-content has-text-centered"><h3 class="title has-text-dark">Are you still creating your images manually?</h3><p class="content has-text-grey is-size-5">
Save time and make each document a unique, personalized experience.</p></div></div></div><div class="columns"><div class="column is-one-third"><article class="card ls-feature-card"><div class="card-content"><figure class="image is-159x159"><img src="img/ui-icon.png" srcset="img/ui-icon@2x.png 320w, img/ui-icon@3x.png 400w, img/ui-icon@3x.png 1024w" title="LandSpeed UI" width="145" height="159"></figure><div class="media-content has-text-centered"><h3 class="title is-5 has-text-weight-bold"><a href="/" class="has-text-dark" title="">1. Create</a></h3><p class="is-size-6">Build your own template.</p></div></div></article></div><div class="column is-one-third"><article class="card ls-feature-card"><div class="card-content"><figure class="image is-159x159"><img src="img/ux-icon.png" srcset="img/ux-icon@2x.png 320w, img/ux-icon@3x.png 400w, img/ux-icon@3x.png 1024w" title="LandSpeed UX" width="145" height="159"></figure><div class="media-content has-text-centered"><h3 class="title is-5 has-text-weight-bold"><a href="/" class="has-text-dark" title="">2. Connect</a></h3><p class="is-size-6">Connect to your
favorite apps.</p></div></div></article></div><div class="column is-one-third"><article class="card ls-feature-card"><div class="card-content"><figure class="image is-159x159"><img src="img/performance-icon.png" srcset="img/performance-icon@2x.png 320w, img/performance-icon@3x.png 400w, img/performance-icon@3x.png 1024w" title="LandSpeed Fast Performance" width="145" height="159"></figure><div class="media-content has-text-centered"><h3 class="title is-5 has-text-weight-bold"><a href="/" class="has-text-dark" title="">3. Automate</a></h3><p class="is-size-6">Generate images and PDFs
dynamically.</p></div></div></article></div></div></div></section>





<!--<newcarrousel/>-->
<div >

</div>

<!--<section class="section ls-hero-image " style="background: linear-gradient(90deg,#377fea 20%,#653dea) #377fea;">
    <div class="container">
        <div class="columns">
            <div class="column is-5 has-text-white">
                <h4 class="title is-3 has-text-white">Personalize Pictures & PDFs</h4>
                <div class="content">
                    <p>Connect your document with almost any app thanks to our REST API or via our integration with Integromat.</p>
                    <p>You can connect your document to Excel, Google Sheets, Google Forms, Google Drive and many more apps.</p>
                </div>
                <a  href="https://app.minutemerge.com/signup" class="ls-button button has-text-weight-bold is-success mybutton">Get Started</a>
                   <a  href="#" class="ls-button button has-text-weight-bold is-success mybuttonmobile">Soon on Mobile...</a>
            </div>
            <div class="column is-6 is-offset-1">

               <img src="../img/MinuteMergePathSVGnoTEXTbluebackgrd5.svg" srcset="../img/MinuteMergePathSVGnoTEXTbluebackgrd5.svg 320w, ../img/MinuteMergePathSVGnoTEXTbluebackgrd5.svg 400w, ../img/MinuteMergePathSVGnoTEXTbluebackgrd5.svg 1024w" title="Integrations" >

            </div>
        </div>
    </div>
</section>-->





<!--<section class="section has-background-primary ls-hero-icons">
    <div class="container has-white-text">
        <div class="columns ls-space-bottom">
            <div class="column is-8 is-offset-2">
                <div class="ls-section-content has-text-centered">
                    <h3 class="title has-text-white">Uses Cases</h3>
                  <p class="content has-text-white is-size-5">
                        Capitalize on low hanging fruit to identify a ballpark value added activity to beta test.
                        Override the digital divide with additional clickthroughs.
                    </p>
                </div>
            </div>
        </div>
        <div class="columns is-multiline is-mobile">
            <div class="column is-one-third-desktop is-half-tablet is-half-mobile ls-icon-snippet has-text-centered has-text-white">
                <div class="ls-icon">
                    <span class="icon">
                        <i aria-hidden="true" class="fas fa-3x fa-cog"></i>
                    </span>
                </div>
                <h5 class="title has-text-wight-bold is-5 has-text-white">Invoices</h5>
                <div class="content">
                    <p>Custom Invoices in Minutes.</p>
                </div>
            </div>
            <div class="column is-one-third-desktop is-half-tablet is-half-mobile ls-icon-snippet has-text-centered has-text-white">
                <div class="ls-icon">
                    <span class="icon">
                        <i aria-hidden="true" class="fas fa-3x fa-desktop"></i>
                    </span>
                </div>
                
                    
                         
                                     
                                     
                         
                         
                    
                
                <h5 class="title has-text-wight-bold is-5 has-text-white">Personalized Marketing</h5>
                <div class="content">
                    <p>Personalized flyer, form or picture.</p>
                </div>
            </div>
            <div class="column is-one-third-desktop is-half-tablet is-half-mobile ls-icon-snippet has-text-centered has-text-white">
                <div class="ls-icon">
                    <span class="icon">
                        <i aria-hidden="true" class="fas fa-3x fa-random"></i>
                    </span>
                </div>
                <h5 class="title has-text-wight-bold is-5 has-text-white">Quotations</h5>
                <div class="content">
                    <p>Send custom Quotes automatically.</p>
                </div>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-half-mobile ls-icon-snippet has-text-centered has-text-white">
                <div class="ls-icon">
                    <span class="icon">
                        <i aria-hidden="true" class="fas fa-3x fa-user"></i>
                    </span>
                </div>
                <h5 class="title has-text-wight-bold is-5 has-text-white">Invitations</h5>
                <div class="content">
                    <p>Specially designed Invitations with personalized with names.</p>
                </div>
            </div>
            <div class="column is-one-third-desktop is-half-tablet is-half-mobile ls-icon-snippet has-text-centered has-text-white">
                <div class="ls-icon">
                    <span class="icon">
                        <i aria-hidden="true" class="fas fa-3x fa-search"></i>
                    </span>
                </div>
                <h5 class="title has-text-wight-bold is-5 has-text-white">Contracts</h5>
                <div class="content">
                    <p>Use dynamic variables to automate <br> any contract in pdf.</p>
                </div>
            </div>
            <div class="column is-one-third-desktop is-half-tablet is-half-mobile ls-icon-snippet has-text-centered has-text-white">
                <div class="ls-icon">
                    <span class="icon">
                        <i aria-hidden="true" class="fas fa-3x fa-bullhorn"></i>
                    </span>
                </div>
                <h5 class="title has-text-wight-bold is-5 has-text-white">Transcripts & Certificates</h5>
                <div class="content">
                    <p>Automate your school's Transcripts <br> & Certificates.</p>
                </div>
            </div>
        </div>
    </div>
</section>-->


<newcarrousel2/>


<div v-show="awesome">
<new3/>
</div>


<section class="section ls-cards-grid " >
    <div class="container">
        <div class="columns">
            <div class="column is-8 is-offset-2">
                <div class="ls-section-content has-text-centered">
                    <h3 class="title has-text-dark">Uses Cases</h3>
                    <p class="content has-text-grey is-size-5">
                        We've got readymade template for you and your business. 
                    </p>
                </div>
            </div>
        </div>

        <div class="columns is-multiline is-mobile">

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/TranscriptThumbnail.png"  width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a @click="openmodalPreview(imgtemplate1)" class="button is-black">Template</a>
                            <a @click="openmodalPreview(imgfinal1)" class="button is-black">Document</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Personalized Documents</a>
                            <p>Build personalized documents with <br>dynamic pictures and text.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="https://minutemerge.s3.us-east-2.amazonaws.com/thumbguest1.png"  title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a @click="openmodalPreview(imgtemplate2)" class="button is-black">Template</a>
                            <a @click="openmodalPreview(imgfinal2)" class="button is-black">Document</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Invitations</a>
                            <p>Customize your Pictures and PDFs.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/refletter4.png" srcset="../img/refletter4.png 320w, ../img/refletter4.png 400w, ../img/refletter4.png 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a @click="openmodalPreview(imgtemplate3)" class="button is-black">Template</a>
                            <a @click="openmodalPreview(imgfinal3)" class="button is-black">Document</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Letters</a>
                            <p>Surround any word by two curly braces to make your letter dynamic and merge fields.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/ACMEthumbnail.png"  width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a @click="openmodalPreview(imgtemplate4)" class="button is-black">Template</a>
                            <a @click="openmodalPreview(imgfinal4)" class="button is-black">Document</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Quotes & Invoices</a>
                            <p>Each customer is different. Adapt each quote to make his experience truly unique.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="https://minutemerge.s3.us-east-2.amazonaws.com/ThumbFight.svg" srcset="https://minutemerge.s3.us-east-2.amazonaws.com/ThumbFight.svg 320w, https://minutemerge.s3.us-east-2.amazonaws.com/ThumbFight.svg 400w, https://minutemerge.s3.us-east-2.amazonaws.com/ThumbFight.svg 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                           <a @click="openmodalPreview(imgtemplate5)" class="button is-black">Template</a>
                            <a @click="openmodalPreview(imgfinal5)" class="button is-black">Document</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Flyers</a>
                            <p>Focus on what matters and let MinuteMerge handle the repetitive workflow for you.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/CompletionCertificateModel.png" srcset="../img/CompletionCertificateModel.png 320w, ../img/CompletionCertificateModel.png 400w, ../img/CompletionCertificateModel.png 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                           <a @click="openmodalPreview(imgtemplate6)" class="button is-black">Template</a>
                            <a @click="openmodalPreview(imgfinal6)" class="button is-black">Document</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Certificates</a>
                            <p>Import any image and save your <br> document in PDF or in PNG.</p>
                        </div>
                    </div>
                </article>
            </div>

        </div>
    </div>
</section>

<!--<section class="section ls-rainbow-gradient">
    <div class="container">
        <div class="columns">
            <div class="column is-4">
                <h3 class="title ls-half-space has-text-white is-3 has-text-bold">Subscribe To Our Newsletter </h3>
                <p class="has-text-white">Never miss our latest <b>tips</b> & <b>tutorials!</b></p>
            </div>
            <div class="column is-5 is-offset-2">
                <div class="field ls-round-input has-background-white">
                    <input class="input has-text-grey" type="text" placeholder="Enter Your Email">
                    <button type="submit" class="button is-success">
                        Subscribe
                    </button>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="section  ls-hero-image" style="background: linear-gradient(90deg,#377fea 20%,#653dea) #377fea;">
    <div class="container">
        <br class="mybutton"><br class="mybutton">
        <div class="columns">
            <div class="column is-8-desktop is-offset-2-desktop has-text-white">
                <h4 class="title is-3 has-text-white">It's time to automate</h4>
                <div class="content">
                    <p>Create your first template easily and boost your productivity.
                    <br>Free trial, no credit card required.
                    </p>

                </div>
                <br>
                <a  href="https://app.minutemerge.com/signup" class="ls-button button has-text-weight-bold is-success mybutton">Get Started</a>
                   <a  href="#" class="ls-button button has-text-weight-bold is-success mybuttonmobile">Soon on Mobile...</a>
                   <br class="mybuttonmobile"><br class="mybuttonmobile"><br class="mybuttonmobile">
            </div>

        </div>
    </div>
</section>


<!--
<section class="section ls-background-light">
    <div class="container">
        <div class="columns">
            <div class="column is-8 is-offset-2">
                <div class="ls-section-content has-text-centered">
                    <h3 class="title has-text-dark">Showcase</h3>
                    <p class="content has-text-grey has-text-weight-light is-size-5">
                        Capitalize on low hanging fruit to identify a ballpark value added activity to beta test.
                        Override the digital divide with additional clickthroughs.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>-->


<!--
<section class="section">
    <div class="container">
        <div class="columns">
            <div class="column is-8-desktop is-offset-2-desktop">
                <div class="ls-section-content has-text-centered ls-space-bottom">
                    <h3 class="title has-text-dark">Contact Us</h3>
                    <p class="content has-text-grey is-size-5">
                        Capitalize on low hanging fruit to identify a ballpark value added activity to beta test.
                        Override the digital divide with additional clickthroughs.
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            
            <div class="column is-7">
                <form action="" class="ls-form-contact">
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <p class="control is-expanded">
                                    <label class="screen-reader-text" for="lsNameInput">Your Name</label>
                                    <input class="input" id="lsNameInput" type="text" placeholder="Name">
                                </p>
                            </div>
                            <div class="field">
                                <p class="control is-expanded">
                                    <label class="screen-reader-text" for="lsEmailInput">Your Email</label>
                                    <input class="input" id="lsEmailInput" type="email" placeholder="Email" value="">
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <label class="screen-reader-text">Message</label>
                                    <textarea class="textarea" placeholder="Message"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <button class="button ls-button-slim has-text-weight-bold is-success">
                                        Send message
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
            <div class="column is-5 ls-info-contact">
                <h4 class="title is-5 has-text-dark ls-half-space">Get in Touch</h4>
                <p class="content has-text-grey">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur totam aliquid porro natus libero, ipsa.
                </p>

                <div class="media ls-item-contact">
                    <div class="media-left">
                        <span class="icon has-text-primary fa-lg">
                            <i aria-hidden="true" class="fas fa-envelope"></i>
                        </span>
                    </div>
                    <a href="#" class="">Email: email@yourmail.com</a>
                </div>
                <div class="media ls-item-contact">
                    <div class="media-left">
                        <span class="icon has-text-primary fa-lg">
                      <i aria-hidden="true" class="fas fa-phone" data-fa-transform="rotate-90"></i>
                    </span>
                    </div>
                    <a href="#" class="">Phone: +123 456 789</a>
                </div>
                <div class="media ls-item-contact">
                    <div class="media-left">
                        <span class="icon has-text-primary fa-lg">
                          <i aria-hidden="true" class="fas fa-globe"></i>
                        </span>
                    </div>
                    <a href="#">Web: www.yoursite.com</a>
                </div>

                <div class="ls-social-buttons">
                    <h4 class="title has-text-dark is-6 is-marginless ls-half-space">Get in Touch</h4>
                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-facebook">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-facebook-f" data-fa-transform="shrink-10"></i>
                        </span>
                    </a>

                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-twitter">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-twitter" data-fa-transform="shrink-10"></i>
                        </span>
                    </a>

                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-instagram">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-instagram" data-fa-transform="shrink-10"></i>
                        </span>
                    </a>

                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-google-plus">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-google-plus-g" data-fa-transform="shrink-10 left-1.2"></i>
                        </span>
                    </a>

                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-pinterest">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-pinterest-p" data-fa-transform="shrink-10"></i>
                        </span>
                    </a>

                </div>
            </div>
        </div>
    </div>
</section>
-->




     <!--  <footer class="footer" style="background: linear-gradient(90deg,#377fea 20%,#653dea) #377fea;">
        <div class="container">
         <div class="columns">
            <div class="column is-4 has-text-centered is-hidden-tablet" >
           
                <h3 class="title has-text-dark">MinuteMerge.com</h3>
                </div>
            <div class="column is-4">
              <div class="level"><a class="level-item" href="/">Home</a>
              <a class="level-item" href="https://blog.minutemerge.com">Blog</a></div>
            </div>
            <div class="column is-4 has-text-centered is-hidden-mobile">
                <a class="title is-4 has-text-dark" >MinuteMerge.com</a>

                </div>
            <div class="column is-4 has-text-right">
              <div class="level"><a class="level-item" href="https://blog.minutemerge.com">Pricing</a><a class="level-item" href="https://app.minutemerge.com/signup">Signup</a></div>
            </div>
          </div>
          <p class="subtitle has-text-centered is-6">&copy; 2021 MinuteMerge. All right reserved.</p>
        </div>
      </footer>-->



<!--<footer class="footer">
    <div class="container">
        <div class="columns has-text-centered-mobile">
            <div class="column is-4">
                <img class="ls-space" src="img/blue-logo.png" srcset="img/blue-logo@2x.png 320w, img/blue-logo@3x.png 400w, img/blue-logo@3x.png 1024w" title="LandSpeed BulmaStyle" width="197" height="45">
                <p class="has-text-grey">BulmaStyle is a marketplace for premium quality Bulma themes & templates for your website. Bulma
                   is a free and open source CSS framework based on Flexbox</p>
            </div>
            <div class="column is-2">
                <h5 class="title has-text-dark is-5">About</h5>
                <ul class="ls-footer-links">
                    <li><a href="/">About</a></li>
                    <li><a href="/">Templates</a></li>
                    <li><a href="/">Integrations</a></li>
                    <li><a href="/">servce</a></li>
                    <li><a href="/">Feature</a></li>
                    <li><a href="/">Testimonials</a></li>
                </ul>
            </div>
            <div class="column is-2">
                <h5 class="title has-text-dark is-5">Resources</h5>
                <ul class="ls-footer-links">
                    <li><a href="/">Info</a></li>
                    <li><a href="/">Tools</a></li>
                    <li><a href="/">Podcasts</a></li>
                    <li><a href="/">Ebooks</a></li>
                    <li><a href="/">Tools</a></li>
                    <li><a href="/">Videos</a></li>
                </ul>
            </div>
            <div class="column is-2">
                <h5 class="title has-text-dark is-5">Company</h5>
                <ul class="ls-footer-links">
                    <li><a href="/">About Us</a></li>
                    <li><a href="/">Support</a></li>
                    <li><a href="/">Contact</a></li>
                    <li><a href="/">Terms &amp; Conditions</a></li>
                    <li><a href="/">FAQ</a></li>
                    <li><a href="/">Press</a></li>
                </ul>
            </div>
        </div>
        <div class="columns ls-footer">
            <div class="column is-5 is-marginless has-text-centered-mobile content has-text-grey">
                <p>Copyright MinuteMerge.com &copy; </p>
            </div>
            <div class="column is-7">
                <ul class="columns ls-bottom-links is-mobile is-multiline is-marginless">
                    <li class="ls-bottom-link"><a href="/">Privacy Policy</a></li>
                    <li class="ls-bottom-link"><a href="/">Customers</a></li>
                    <li class="ls-bottom-link"><a href="/">Support</a></li>
                    <li class="ls-bottom-link"><a href="/">New Features</a></li>
                </ul>
            </div>
        </div>
    </div>
</footer>-->

</div>
</template>



<script>
//require("../js/main.js") 
require("../../css/main.css") 
//import firebase from "firebase/app";


import truenav from "../components/truenav";
//import newcarrousel from "../components/newcarrousel";
import newcarrousel2 from "../components/newcarrousel2";
import new3 from "../components/new3";


import previewimage1 from "../components/previewimage1";

export default {
  components: {
      truenav,
     // newcarrousel,
      newcarrousel2,
      new3,
      previewimage1

  },
  data () {
    return {
        awesome:false,
        ratio1:'image is-4by3',
        imgtemplate1:['https://minutemerge.s3.us-east-2.amazonaws.com/TranscriptModel2.png'],
        imgfinal1:['https://minutemerge.s3.us-east-2.amazonaws.com/Transcript1.png','https://minutemerge.s3.us-east-2.amazonaws.com/Transcript2.png','https://minutemerge.s3.us-east-2.amazonaws.com/Transcript3.png','https://minutemerge.s3.us-east-2.amazonaws.com/Transcript4.png','https://minutemerge.s3.us-east-2.amazonaws.com/Transcript5.png','https://minutemerge.s3.us-east-2.amazonaws.com/Transcript6.png','https://minutemerge.s3.us-east-2.amazonaws.com/Transcript7.png','https://minutemerge.s3.us-east-2.amazonaws.com/Transcript8.png'],
        ratio2:'image is-4by3',
        imgtemplate2:['https://minutemerge.s3.us-east-2.amazonaws.com/Model1.png'],
        imgfinal2:['https://minutemerge.s3.us-east-2.amazonaws.com/700A.png','https://minutemerge.s3.us-east-2.amazonaws.com/700B.png','https://minutemerge.s3.us-east-2.amazonaws.com/700C.png','https://minutemerge.s3.us-east-2.amazonaws.com/700F.png','https://minutemerge.s3.us-east-2.amazonaws.com/700E.png'],
        ratio3:'image is-4by3',
        imgtemplate3:['https://minutemerge.s3.us-east-2.amazonaws.com/Template001.PNG'],
        imgfinal3:['https://minutemerge.s3.us-east-2.amazonaws.com/download+(31).png'],
        ratio4:'image is-4by3',
        imgtemplate4:['https://minutemerge.s3.us-east-2.amazonaws.com/ACMEmodel+(2).png'],
        imgfinal4:['https://minutemerge.s3.us-east-2.amazonaws.com/ACMEexample.png'],
        ratio5:'image is-3by2',
        imgtemplate5:['https://minutemerge.s3.us-east-2.amazonaws.com/MyTournaModel.png'],
        imgfinal5:['https://minutemerge.s3.us-east-2.amazonaws.com/MyTournament1.png','https://minutemerge.s3.us-east-2.amazonaws.com/MyTournament2.png','https://minutemerge.s3.us-east-2.amazonaws.com/template111.png'],
        ratio6:'image is-3by2',
        imgtemplate6:['https://minutemerge.s3.us-east-2.amazonaws.com/CompletionCertificateModel.png'],
        imgfinal6:['https://minutemerge.s3.us-east-2.amazonaws.com/Completion+CertificateExample1.png','https://minutemerge.s3.us-east-2.amazonaws.com/Completion+CertificateExample3.png','https://minutemerge.s3.us-east-2.amazonaws.com/Completion+CertificateExample4.png','https://minutemerge.s3.us-east-2.amazonaws.com/Completion+CertificateExample2.png','https://minutemerge.s3.us-east-2.amazonaws.com/Completion+CertificateExample5.png'],

  }
},

watch:{
//user: function() {  if (this.user) { this.$router.push('/templates') }
//else {}
//}
},
created: function () {
  
//document.getElementsByTagName('html')[0].style.background = "white"
},
mounted: function() {
//this.$router.push('/templates')
// /return this.$store.state.user.user
},

methods: {
    openmodalPreview(val) {

        //pickrandom img
        var randomItem = val[Math.floor(Math.random()*val.length)]
        this.$refs.preview1.Display(randomItem);

    },
},


}
</script>






<style>


@media only screen and (max-width: 706px) {
  .mybutton {
display:none;
  }

  .mybuttonmobile {

  }
}

@media only screen and (min-width: 706px) {
  .mybutton {

  }

  .mybuttonmobile {
display:none;
  }
}

</style>
